module.exports = __webpack_public_path__ + "static/DontOpenYourEyes2-f6a2d45b146e449d3a62099059bca16a.webp";